import axios from 'axios'
import { config } from './httpurl'
import qs from 'qs'

// 获取用户指引
export const getUserGuide = () => {
  return axios({
    url: config.root + 'orbita_cloud/platform/product/product-operation-manual', 
    method: 'GET',
  })
}
// 获取遥感影像产品
export const getImageProduct = () => {
  return axios({
    url: config.root + 'orbita_cloud/platform/product/image-product', 
    method: 'GET',
  })
}
// 获取专题信息产品
export const getSpecialProduct = () => {
  return axios({
    url: config.root + 'orbita_cloud/platform/product/thematic-info-product', 
    method: 'GET',
  })
}
// 获取行业应用方案列表
export const getApplicationList = () => {
  return axios({
    url: config.root + 'orbita_cloud/platform/product/application-scheme/list', 
    method: 'GET',
  })
}
// 获取行业应用方案详情
export const getApplicationDetails = (id) => {
  return axios({
    url: config.root + 'orbita_cloud/platform/product/application-scheme/details/'+id, 
    method: 'GET',
  })
}